module.exports = __webpack_public_path__ + "img/logo.151783cf.png";